module.exports = __webpack_public_path__ + "static/media/kit_carLineTracking.e72c89a9.png";